import { Input, Tooltip } from 'antd';
import PhoneOutlined from '@/assets/img/icon@2x.webp';
import { agentSessionUpsertTTS, checkBusiness } from '@/api/grt/ai';
import { useJoin } from '@/libTTS/useCommon';
import aigcConfig from '@/configTTS';
import { getUserId } from '@/utils/Page';
import Config from '@/configTTS';
import ToastUtils from '@/utils/ToastUtils';
import { useWebSender } from '@/pages/hooks/useWebSender';
import s from '@/pages/Web/PageComponents/style.module.scss';
import { inject, observer } from 'mobx-react';
import useTTSHandler from '@/pages/hooks/useTTSHandler';
const ChatTTS = (porps) => {
    const { grtAi, skillStore, simulation, chatStore, sessionStore, preQuestionStore, voiceCallStore } = porps.store;
    let { checkIsLogin, currentSessionMapId: currentSessionMapIdRef, formatSessionList, linkToSession, agentId } = chatStore;
    let { sessionMap, originSessionList: sessionListRef, changeCurrentSessionMapId } = sessionStore;
    let { curSkill } = skillStore;
    let skillId = curSkill?.ability_id || '';
    const {
        isNewSessionRef,

        onInputVisibilityChange,
        onShowTTSComponent,
        sessionId,
        messages,
        activeReportId,
        handleDeerFlowStop,
        stopHistoryPolling,
        onStop
    } = porps;
    const { isNewSession, setIsNewSession, setHideTTSActions, handleTTSToggle: onTTSToggle } = voiceCallStore;
    const [joining, dispatchJoin] = useJoin();
    const username = aigcConfig.BaseConfig.UserId;
    const roomId = aigcConfig.BaseConfig.RoomId;
    const { isSubmitting, setIsSubmitting, lastSubmitTimeRef } = useWebSender({
        sessionId,
        messages,
        activeReportId,
        handleDeerFlowStop,
        stopHistoryPolling,
        onStop
    });
    const checkCanUse = async () => {
        let res = await checkBusiness({ agent_id: agentId });
        console.log('checkCanUse', res);
        if (!res || !res.success || !res.data) {
            ToastUtils.showToast('该智能体未对外开放，请联系管理员' || []);
            return false;
        }
        return true;
    };
    const onClickTTS = async () => {
        // 防止暴力点击
        const currentTime = Date.now();
        if (isSubmitting || currentTime - lastSubmitTimeRef.current < 1000) {
            return false;
        }

        // 设置提交状态，防止重复点击
        setIsSubmitting(true);
        lastSubmitTimeRef.current = currentTime;

        let isLogin = await checkIsLogin();
        if (!isLogin) {
            checkIsLogin(true);
            setIsSubmitting(false);
            return false;
        }
        let isCanUse = await checkCanUse();
        if (!isCanUse) {
            setIsSubmitting(false);
            return false;
        }
        if (setHideTTSActions) {
            setHideTTSActions(false);
            console.log('setHideTTSActions', setHideTTSActions);
        }
        // 检查是否正在生成结果
        if (
            sessionMap[currentSessionMapIdRef] &&
            sessionMap[currentSessionMapIdRef]?.loading &&
            !sessionMap[currentSessionMapIdRef]?.thinking &&
            !sessionMap[currentSessionMapIdRef]?.speaking
        ) {
            ToastUtils.showToast('当前正在生成结果，请稍后操作');
            setIsSubmitting(false);
            return false;
        }
        if (!joining) {
            dispatchJoin(
                {
                    username,
                    roomId,
                    publishAudio: true
                },
                false
            );
        }
        if (!currentSessionMapIdRef) {
            agentSessionUpsertTTS({
                user_id: getUserId(),
                agent_id: agentId,
                skill_id: String(curSkill?.ability_id),
                question: '新问答对话'
            }).then((res) => {
                if (!currentSessionMapIdRef) {
                    const skillIdData = skillId || '';
                    const newSessionId = res.data;
                    changeCurrentSessionMapId(newSessionId);
                    linkToSession(newSessionId, { replace: true });
                    let curList = sessionListRef ? sessionListRef : [];
                    let data = [{ session_name: '新问答对话', time_range: '1', session_id: newSessionId, skill_id: skillIdData }, ...curList];
                    console.log('setSessionList', data);
                    formatSessionList(data);
                    setIsNewSession(true);
                }
                console.log('agentSessionUpsertTTS', res.data);
            });
        }
        Config.WelcomeSpeech = 'Hi，你已开启语音通话，你可以随时向我提问哦';
        Config.TTSMode = true;

        if (onTTSToggle) {
            onTTSToggle();
        }
        onInputVisibilityChange && onInputVisibilityChange(false);
        onShowTTSComponent && onShowTTSComponent(true);
        setTimeout(() => {
            setIsSubmitting(false);
        }, 2000);
    };
    return (
        <Tooltip title={'语音通话'} placement="top">
            {
                <div className={s['chat-tts']}>
                    <img
                        src={PhoneOutlined}
                        alt=""
                        onClick={() => {
                            onClickTTS();
                            if (setHideTTSActions) {
                                setHideTTSActions(false);
                            }
                        }}
                        className={s['tts-img']}
                    />
                </div>
            }
        </Tooltip>
    );
};
export default inject('store')(observer(ChatTTS));
